

































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";
import Spinner from "@/components/Spinner.vue";

@Component({
  components: {
    Spinner
  }
})
export default class AgentReadySwitch extends Vue {
  @Action("toggleAgentReady") toggleAgentReady!: Function;
  @Getter("availableStatus") availableStatus!: boolean;
  onToggle(val: any) {}

  get available() {
    return this.availableStatus;
  }

  set available(val: boolean) {
    // dummy setter to remove linting error
  }
}
